import { render, staticRenderFns } from "./DBSearch.vue?vue&type=template&id=d91626f2&scoped=true&"
import script from "./DBSearch.vue?vue&type=script&lang=js&"
export * from "./DBSearch.vue?vue&type=script&lang=js&"
import style0 from "./DBSearch.vue?vue&type=style&index=0&id=d91626f2&lang=sass&scoped=true&"
import style1 from "./DBSearch.vue?vue&type=style&index=1&id=d91626f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91626f2",
  null
  
)

export default component.exports